import React from "react";
//#region types
import { FormFieldProps, GenericFormField } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import useCheckVisibility from "../hooks/useCheckVisibility";
import FormRow from "../formRow";
//#endregion

function SubFormFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field } = props;

  const { getFieldHidden } = useCheckVisibility<T>();
  const fields = field.innerFields as Record<keyof T, GenericFormField<T>>;

  return (
    <>
      {Object.entries(fields).map(([key, field], index) => {
        return (
          !getFieldHidden(field.hidden) && (
            <FormRow<T> {...props} key={`formField-${name}.${key}`} name={`${name}.${key}`} field={field} />
          )
        );
      })}
    </>
  );
}

export default SubFormFormField;
